import { Button } from 'foundations-components/transitional/components/Button';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFullUrl } from 'hubspot-url-utils';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InheritBackground = styled.div.withConfig({
  displayName: "AccountDisabledAlert__InheritBackground",
  componentId: "sc-1bzzlam-0"
})(["background-color:inherit;"]);
export default function AccountDisabledAlert(props) {
  const {
    inboxId
  } = props;
  return /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "700",
    paddingBlockEnd: "1500",
    marginBlock: "1000",
    paddingInline: "400",
    textAlign: "center",
    children: /*#__PURE__*/_jsxs(InheritBackground, {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'customerDataCommunicator.Communicator.WhatsApp.accountDisabledAlert.title'
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          marginBlockEnd: "500",
          paddingInline: "1400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'customerDataCommunicator.Communicator.WhatsApp.accountDisabledAlert.info'
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Button, {
          href: `${getFullUrl('app')}/live-messages-settings/${PortalIdParser.get()}/inboxes/${inboxId || ''}/channels`,
          target: "_blank",
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'customerDataCommunicator.Communicator.WhatsApp.accountDisabledAlert.settingsLabel'
          })
        })
      })]
    })
  });
}
AccountDisabledAlert.displayName = 'AccountDisabledAlert';